const opcoesAlteracaoLoteEnum = {
    DANOS_MATERIAIS: 1,
    DANOS_CORPORAIS: 2,
    DANOS_MORAIS_ESTETICOS: 3,
    GARANTIA_UNICA:4,
    FRANQUIA_GARANTIA_UNICA: 5,
    FRANQUIA_DANOS_MATERIAIS: 6,
    TIPO_COBERTURA: 7,
    KM_ASSISTENCIA: 8,
    APP_MORTE: 9,
    APP_DMHO: 10,
    APP_INVALIDEZ: 11,
};

const camposPorOpcao = {
    [opcoesAlteracaoLoteEnum.APP_MORTE]: "appMorte",
    [opcoesAlteracaoLoteEnum.APP_DMHO]: "despesasMedicasHospitalaresEOdontologicas",
    [opcoesAlteracaoLoteEnum.APP_INVALIDEZ]: "appInvalidez",
};

export default {
    opcoesAlteracaoLoteEnum,
    camposPorOpcao,
    campoDaOpcao(idOpcao) {
        if (typeof idOpcao !== "number") {
            return null;
        }
        return camposPorOpcao[idOpcao] || null;
    },
    aplicarValorEmLote(dadosPlanilha, itensSelecionados, campo, valor) {
        if (!dadosPlanilha || !itensSelecionados) {
            return dadosPlanilha;
        }
        for (var i = 0; i < dadosPlanilha.length; i++) {
            for (var itemSelecionado of itensSelecionados) {
                if (dadosPlanilha[i].item == itemSelecionado) {
                    dadosPlanilha[i][campo] = valor;
                }
            }
        }
        return dadosPlanilha;
    }
}



// WEBPACK FOOTER //
// ./src/helpers/alteracao-lote.js